/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}
/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadBusinessMetaDataDetails(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadOrganizationDetails(searchFilter) {
  return await api
    .post(`/org/getorganization`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadUserRoleDetails(searchFilter) {
  return await api
    .post(`/org/getrole`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTokenExpiryDetails(searchFilter) {
  return await api
    .post(`/masters/gettokenexpires`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadActivitiesDetails(searchFilter) {
  return await api
    .post(`/auth/users/getactivitiesperformed`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadUsersDetails(searchFilter) {
  return await api
    .post(`/auth/users/getorgusers`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadOrganizationDetails,
  loadUserRoleDetails,
  loadUsersDetails,
  loadActivitiesDetails,
  loadTokenExpiryDetails,
  loadRecordsMetaData,
  loadBusinessMetaDataDetails,
};

export default remotes;
